module.exports = __webpack_public_path__ + "img/Boheme.48fc554.jpg";